var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.66699C9 3.21928 8.55228 3.66699 8 3.66699C7.44772 3.66699 7 3.21928 7 2.66699C7 2.11471 7.44772 1.66699 8 1.66699C8.55228 1.66699 9 2.11471 9 2.66699Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.00033C9 8.55261 8.55228 9.00033 8 9.00033C7.44772 9.00033 7 8.55261 7 8.00033C7 7.44804 7.44772 7.00033 8 7.00033C8.55228 7.00033 9 7.44804 9 8.00033Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.3337C8.55228 14.3337 9 13.8859 9 13.3337C9 12.7814 8.55228 12.3337 8 12.3337C7.44772 12.3337 7 12.7814 7 13.3337C7 13.8859 7.44772 14.3337 8 14.3337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/threeDotsIcon.7a6e550ae093902b2cde04458f00e07c.svg";
export { ForwardRef as ReactComponent };